// extracted by mini-css-extract-plugin
module.exports = {"top":"Top_top__2WbI6","wrap":"Top_wrap__UfuFb","back":"Top_back__84Tzw","close":"Top_close__oZAO6","icon":"Top_icon__zm8Kg","title":"Top_title__jXPAm","sticky":"Top_sticky__TpfxB"};